// Legacy service and Redux modules are still JavaScript; keep this migration focused on the component boundary.
// @ts-nocheck
import React, { useEffect, useMemo, useRef, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import CustomError from "../../../utils/customError";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  CONSUMPTION_TAX_RATES,
  CUSTOMER_TAGS,
  DISPLAY_METHOD_TAX_OPTIONS,
  ITEM_TYPES,
  ORDER_PLATFORM,
  ORDER_TYPES,
  SWAL_SETTINGS,
} from "../../../utils/Constants";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getAddonKey,
  getPersistentSessionKey,
  getSubTotalQRApp,
  getTranslatedKey,
  getUniqueID,
  handleServerValidations,
  isSameArray,
  pluralText,
  removePersistentSessionKey,
  setPersistentSessionKey,
  showPrice,
} from "../../../utils/commonfunction";
import Swal from "sweetalert2";
import trash from "../../../assets/restaurant/images/trash.svg";
import { useTranslation } from "react-i18next";
import { createOrder, detail, lineStatus, lineVerify } from "../services/order.service";
import { getRestaurantSettings } from "../../restaurant/services/profile.services";
import { getTaxBracketBreakdown } from "../../../utils/taxBreakdown";
import {
  endVisit,
  knownGuestCount,
  readReviewDraft,
  readVisitCart,
  saveReviewDraft,
  saveVisitCart,
} from "../utils/qrVisit";
import { menuItemDetail, spiceLevelsOptions } from "../services/menu.service";
import { SetCartLength } from "../../../redux/slices/qrcodeDetails";
import LineVerificationCard from "../components/LineVerificationCard";
import LineTroubleModal from "../components/LineTroubleModal";
import SetMenuAddonPicker from "../components/SetMenuAddonPicker";
import { expandByQuantity, unitsOf } from "../../../utils/addonQuantity";
import { calculateSetMenuPrice } from "../../cashier/utils/setMenuAddons";
import { postAppMessage } from '../utils/nativeBridge';

/**
 * Turn each addon's `quantity` count into that many entries, and drop the count.
 *
 * The cart keeps a count so a line stays editable in one place; the order wire
 * contract is repeat entries, because that is what the backend prices
 * (`resolveOrderAddons` prices per entry, `sumSetLine` sums them) and what the
 * kitchen payload collapses into "name ×N". The line's own money is unchanged —
 * it was already computed with the count applied when the item was added.
 */
export const expandAddonQuantities = (items: any[] = []) =>
  (items || []).map((item) => {
    if (!Array.isArray(item?.addons) || !item.addons.length) {
      return item;
    }
    return {
      ...item,
      // `dropQuantity`: the wire contract is repeat entries and no count.
      addons: expandByQuantity(item.addons, { dropQuantity: true }),
    };
  });

export default function ReviewOrder() {
  const QR_LINE_RETURN_CONTEXT_KEY = "qr_line_return_context";
  const QR_LINE_PENDING_FRIEND_CHECK_KEY = "qr_line_pending_friend_check";
  const QR_LINE_DEFAULT_ERROR = "LINE login was not completed. Please try again.";
  const LINE_PENDING_FRIEND_TTL_MS = 30 * 60 * 1000;
  const LINE_STATUS_DEBOUNCE_MS = 500;
  const LINE_STATUS_POLL_DELAY_MS = 5000;
  const LINE_STATUS_MAX_ATTEMPTS = 6;
  const LINE_STATUS_MAX_FAILURES = 3;
  const LINE_STATUS_MAX_WINDOW_MS = 30 * 1000;
  const queryParams = new URLSearchParams(window.location.search);
  const restaurant_id = queryParams.get("restaurant_id");
  const table_id = queryParams.get("table_id");
  const getStoredCartItems = () => readVisitCart(restaurant_id, table_id);
  const order_type = queryParams.get("order_type");
  const [numberOfPersonOptions, setNumberOfPersonOptions] = useState([]);
  const tableDetails = useSelector((state) => {
    return state.QrOrderToken.tableDetails;
  });
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [token, setToken] = useState(getPersistentSessionKey("qr_user_token"));
  const order_id = queryParams.get("order_id")
    ? queryParams.get("order_id")
    : null;
  const [orderDetail, setOrderDetail] = useState(null);
  const [customerDetails, setCustomerDetails] = useState(
    location?.state?.customerDetails || readReviewDraft(restaurant_id, table_id) || null
  );
  const ChargeSettings = useSelector((state) => {
    return state.QrOrderToken.ChargeSettings;
  });
  // console.log(ChargeSettings.service_charge)
  const [pricing, setPricing] = useState({
    subtotal: 0,
    tax_price: 0,
    grand_total: 0,
    total_tax_8: 0,
    total_tax_10: 0,
    tax_amount_8: 0,
    tax_amount_10: 0,
    service_charge: 0,
    grand_cost_price: 0
  });
  // const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [currentItem, setCurrentItem] = useState({});
  const dispatch = useDispatch();
  const base = queryParams.get("base");
  const staff_id = queryParams.get('staff_id');
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [optionsData, setOptionsData] = useState([]);
  const [lineAuth, setLineAuth] = useState(() => {
    const stored = getPersistentSessionKey("qr_line_auth");
    if (!stored) return null;
    try {
      const parsed = JSON.parse(stored);
      // If the stored session belongs to a different table/restaurant, invalidate it
      if (
        (table_id && String(parsed?.table_id) !== String(table_id)) ||
        (restaurant_id && String(parsed?.restaurant_id) !== String(restaurant_id))
      ) {
        removePersistentSessionKey("qr_line_auth");
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  });
  const [lineAuthError, setLineAuthError] = useState(getPersistentSessionKey("qr_line_auth_error") || "");
  const [lineLoading, setLineLoading] = useState(false);
  const [lineStatusChecking, setLineStatusChecking] = useState(false);
  const [pendingFriendCheck, setPendingFriendCheckState] = useState(() => {
    try {
      const stored = getPersistentSessionKey(QR_LINE_PENDING_FRIEND_CHECK_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });
  const lineStatusRequestInFlightRef = useRef(false);
  const lastLineStatusTriggerRef = useRef(0);
  const lastLineStatusRequestStartedRef = useRef(0);
  const lineStatusPollTimeoutRef = useRef(null);
  const lineStatusPollStateRef = useRef({
    startedAt: 0,
    attempts: 0,
    failures: 0,
  });
  const lineReturnContextRestoredRef = useRef(false);
  const lineSessionTokenRef = useRef(lineAuth?.line_session_token || null);

  const lineAddFriendUrl =
    lineAuth?.add_friend_url ||
    ChargeSettings?.line_add_friend_url ||
    ChargeSettings?.line_add_friend_qr_value ||
    null;
  const hasActivePendingFriendCheck = useMemo(() => {
    if (!pendingFriendCheck?.created_at) {
      return false;
    }

    return Date.now() - Number(pendingFriendCheck.created_at) < LINE_PENDING_FRIEND_TTL_MS;
  }, [pendingFriendCheck]);

  const clearPendingFriendCheck = () => {
    removePersistentSessionKey(QR_LINE_PENDING_FRIEND_CHECK_KEY);
    setPendingFriendCheckState(null);
  };

  const persistPendingFriendCheck = (value) => {
    setPersistentSessionKey(QR_LINE_PENDING_FRIEND_CHECK_KEY, JSON.stringify(value));
    setPendingFriendCheckState(value);
  };

  const persistLineReturnContext = () => {
    setPersistentSessionKey(
      QR_LINE_RETURN_CONTEXT_KEY,
      JSON.stringify({
        pathname: location.pathname,
        search: location.search,
        scrollY: window.scrollY || 0,
        created_at: Date.now(),
      })
    );
  };

  const syncLineAuth = (nextLineAuth) => {
    setPersistentSessionKey("qr_line_auth", JSON.stringify(nextLineAuth));
    removePersistentSessionKey("qr_line_auth_error");
    lineSessionTokenRef.current = nextLineAuth?.line_session_token || null;
    setLineAuth(nextLineAuth);
    setLineAuthError("");
  };

  const getStoredPendingFriendCheck = () => {
    try {
      const stored = getPersistentSessionKey(QR_LINE_PENDING_FRIEND_CHECK_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  };
  const getLatestStoredLineAuth = () => {
    try {
      const stored = getPersistentSessionKey("qr_line_auth");
      if (!stored) return null;
      const parsed = JSON.parse(stored);
      if (
        (table_id && String(parsed?.table_id) !== String(table_id)) ||
        (restaurant_id && String(parsed?.restaurant_id) !== String(restaurant_id))
      ) {
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    if (token && token.length) {
      spiceLevelsOptions({}, { token: token })
        .then((response) => {
          setOptionsData(response.data.list);
        })
        .catch((err) => { console.error(err) });
    }
  }, [token]);

  useEffect(() => {
    const stored = getPersistentSessionKey("qr_line_auth");
    let parsedLineAuth = stored ? JSON.parse(stored) : null;
    if (parsedLineAuth) {
      if (
        (table_id && String(parsedLineAuth?.table_id) !== String(table_id)) ||
        (restaurant_id && String(parsedLineAuth?.restaurant_id) !== String(restaurant_id))
      ) {
        removePersistentSessionKey("qr_line_auth");
        parsedLineAuth = null;
      }
    }
    lineSessionTokenRef.current = parsedLineAuth?.line_session_token || null;
    setLineAuth(parsedLineAuth);
    setLineAuthError(getPersistentSessionKey("qr_line_auth_error") || "");
    setPendingFriendCheckState(getStoredPendingFriendCheck());
  }, [location.search, table_id, restaurant_id]);

  useEffect(() => {
    if (lineReturnContextRestoredRef.current) {
      return;
    }

    try {
      const saved = getPersistentSessionKey(QR_LINE_RETURN_CONTEXT_KEY);
      const parsed = saved ? JSON.parse(saved) : null;
      if (parsed?.pathname === location.pathname && typeof parsed.scrollY === "number") {
        lineReturnContextRestoredRef.current = true;
        window.setTimeout(() => {
          window.scrollTo({ top: parsed.scrollY, behavior: "auto" });
          removePersistentSessionKey(QR_LINE_RETURN_CONTEXT_KEY);
        }, 0);
      }
    } catch {
      removePersistentSessionKey(QR_LINE_RETURN_CONTEXT_KEY);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!pendingFriendCheck?.created_at) {
      return;
    }

    if (!hasActivePendingFriendCheck) {
      clearPendingFriendCheck();
      setLineAuthError((prev) => prev || t("line_friend_confirmation_expired"));
    }
  }, [hasActivePendingFriendCheck, pendingFriendCheck]);

  const performLineStatusCheck = async (reason = "manual", options = {}) => {
    const { force = false } = options;
    if (
      base !== ORDER_PLATFORM.WEB ||
      !token ||
      !lineAuth?.line_session_token ||
      (!force && lineAuth?.is_blocked === true)
    ) {
      return null;
    }

    const now = Date.now();
    if (lineStatusRequestInFlightRef.current) {
      return null;
    }

    if (
      reason !== "manual" &&
      (now - lastLineStatusTriggerRef.current < LINE_STATUS_DEBOUNCE_MS ||
        now - lastLineStatusRequestStartedRef.current < LINE_STATUS_DEBOUNCE_MS)
    ) {
      return null;
    }

    lineStatusRequestInFlightRef.current = true;
    lastLineStatusTriggerRef.current = now;
    lastLineStatusRequestStartedRef.current = now;
    setLineStatusChecking(true);

    try {
      const response = await lineStatus(
        { line_session_token: lineAuth.line_session_token },
        { token }
      );

      if (response?.success && response?.data) {
        const nextLineAuth = {
          ...lineAuth,
          ...response.data,
        };
        syncLineAuth(nextLineAuth);

        if (response?.data?.is_friend === true || response?.data?.is_blocked === true) {
          clearPendingFriendCheck();
        }
      } else if (response?.success === false) {
        const wasVerified = lineAuth?.is_friend === true;
        if (!wasVerified) {
          const message = response?.message || t("line_login_required");
          setLineAuthError(message);

          if (/log in with line/i.test(message)) {
            removePersistentSessionKey("qr_line_auth");
            lineSessionTokenRef.current = null;
            setLineAuth(null);
            clearPendingFriendCheck();
          }
        }
      }

      return response;
    } catch (error) {
      return {
        success: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          t("line_status_unavailable"),
      };
    } finally {
      lineStatusRequestInFlightRef.current = false;
      setLineStatusChecking(false);
    }
  };

  const startLineLogin = () => {
    setLineLoading(true);
    setLineAuthError("");
    clearPendingFriendCheck();
    persistLineReturnContext();
    lineVerify({ restaurant_id, table_id, return_path: location.pathname })
      .then((response) => {
        if (response?.success && response?.data?.authorize_url) {
          window.location.href = response.data.authorize_url;
          return;
        }

        setLineAuthError(handleServerValidations(response) || QR_LINE_DEFAULT_ERROR);
      })
      .catch((error) => {
        setLineAuthError(error?.response?.data?.message || error?.message || QR_LINE_DEFAULT_ERROR);
      })
      .finally(() => {
        setLineLoading(false);
      });
  };

  const startAddFriendFlow = () => {
    if (!lineAddFriendUrl) {
      return;
    }

    persistLineReturnContext();
    persistPendingFriendCheck({
      created_at: Date.now(),
      restaurant_id,
      table_id,
      return_path: location.pathname,
    });

    const userAgent = window.navigator.userAgent || "";
    const isAndroid = /Android/i.test(userAgent);
    const isAppleMobile = /iPhone|iPad|iPod/i.test(userAgent) ||
      (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
    const isMobileDevice = isAndroid || isAppleMobile || Boolean(window.navigator.userAgentData?.mobile);
    const lineDeepLink = lineAddFriendUrl.replace(
      /^https:\/\/line\.me\/R\/ti\/p\//i,
      "line://ti/p/"
    );
    const linePath = lineDeepLink.replace(/^line:\/\//i, "");
    const androidIntentLink = `intent://${linePath}#Intent;scheme=line;package=jp.naver.line.android;end`;

    if (!isMobileDevice || lineDeepLink === lineAddFriendUrl) {
      window.location.assign(lineAddFriendUrl);
      return;
    }

    let fallbackTimer;
    const cancelFallback = () => {
      window.clearTimeout(fallbackTimer);
      window.removeEventListener("pagehide", cancelFallback);
      window.removeEventListener("visibilitychange", cancelFallback);
    };

    fallbackTimer = window.setTimeout(() => {
      cancelFallback();
      window.location.assign(lineAddFriendUrl);
    }, 5000);
    window.addEventListener("pagehide", cancelFallback, { once: true });
    window.addEventListener("visibilitychange", cancelFallback, { once: true });
    window.location.assign(isAndroid ? androidIntentLink : lineDeepLink);
  };

  const refreshFriendStatus = async () => {
    if (!lineAuth?.line_session_token) {
      startLineLogin();
      return;
    }

    setLineAuthError("");
    const currentPending =
      getStoredPendingFriendCheck() ||
      {
        created_at: Date.now(),
        restaurant_id,
        table_id,
        return_path: location.pathname,
      };
    persistPendingFriendCheck(currentPending);
    const response = await performLineStatusCheck("manual");

    if (!response?.success) {
      setLineAuthError(response?.message || t("line_status_unavailable"));
    }
  };

  useEffect(() => {
    if (
      base !== ORDER_PLATFORM.WEB ||
      !token ||
      !lineAuth?.line_session_token ||
      lineAuth?.is_friend === true ||
      lineAuth?.is_blocked === true ||
      !hasActivePendingFriendCheck
    ) {
      if (lineStatusPollTimeoutRef.current) {
        window.clearTimeout(lineStatusPollTimeoutRef.current);
        lineStatusPollTimeoutRef.current = null;
      }
      return;
    }

    lineStatusPollStateRef.current = {
      startedAt: Date.now(),
      attempts: 0,
      failures: 0,
    };

    const scheduleNextPoll = () => {
      lineStatusPollTimeoutRef.current = window.setTimeout(async () => {
        const pollState = lineStatusPollStateRef.current;
        const elapsed = Date.now() - pollState.startedAt;

        if (
          !hasActivePendingFriendCheck ||
          pollState.attempts >= LINE_STATUS_MAX_ATTEMPTS ||
          pollState.failures >= LINE_STATUS_MAX_FAILURES ||
          elapsed >= LINE_STATUS_MAX_WINDOW_MS
        ) {
          clearPendingFriendCheck();
          if (!lineAuth?.is_friend && !lineAuth?.is_blocked) {
            setLineAuthError((prev) => prev || t("line_friend_recheck_hint"));
          }
          return;
        }

        pollState.attempts += 1;
        const response = await performLineStatusCheck("poll");
        pollState.failures = response?.success ? 0 : pollState.failures + 1;

        if (response?.data?.is_friend === true || response?.data?.is_blocked === true) {
          clearPendingFriendCheck();
          return;
        }

        scheduleNextPoll();
      }, LINE_STATUS_POLL_DELAY_MS);
    };

    performLineStatusCheck("resume");
    scheduleNextPoll();

    return () => {
      if (lineStatusPollTimeoutRef.current) {
        window.clearTimeout(lineStatusPollTimeoutRef.current);
        lineStatusPollTimeoutRef.current = null;
      }
    };
  }, [
    base,
    hasActivePendingFriendCheck,
    lineAuth?.is_blocked,
    lineAuth?.is_friend,
    lineAuth?.line_session_token,
    location.pathname,
    restaurant_id,
    table_id,
    token,
  ]);

  useEffect(() => {
    if (
      base !== ORDER_PLATFORM.WEB ||
      !lineAuth?.line_session_token
    ) {
      return undefined;
    }

    const triggerReturnStatusCheck = () => {
      performLineStatusCheck("focus", { force: true });
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        triggerReturnStatusCheck();
      }
    };

    window.addEventListener("focus", triggerReturnStatusCheck);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("focus", triggerReturnStatusCheck);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [
    base,
    lineAuth?.line_session_token,
    token,
  ]);

  useEffect(() => {
    if (
      base !== ORDER_PLATFORM.WEB ||
      !lineAuth?.line_session_token
    ) {
      return;
    }
    performLineStatusCheck("screen-enter", { force: true });
  }, [base, lineAuth?.line_session_token, location.pathname]);


  const getSpiceName = (spiceLevel) => {
    if (!spiceLevel) return '';
    if (typeof spiceLevel === 'object') {
      return getTranslatedKey('name', spiceLevel) || spiceLevel.name;
    }
    const found = optionsData?.find(s => s._id === spiceLevel);
    return found ? (getTranslatedKey('name', found) || spiceLevel) : spiceLevel;
  };

  useEffect(() => {
    if (tableDetails && tableDetails?.capacity) {
      let i = 1;
      const numberOfPersonOptionsTemp = [];
      for (i; i <= tableDetails?.capacity; i++) {
        numberOfPersonOptionsTemp.push(i);
      }
      setNumberOfPersonOptions(numberOfPersonOptionsTemp);
    }
  }, [tableDetails]);

  useEffect(() => {
    if (order_id) {
      detail({ o_id: order_id }, { token: token })
        .then((response) => {
          setOrderDetail(response?.data);
          let customerData = {
            customer_name: response?.data?.customer_name || "",
            customer_phone_number:
              response?.data?.customerDetails?.customer_phone_number || "",
            number_of_persons: response?.data?.number_of_persons || "",
            customer_note: "",
            tag: response?.data?.tag
          };
          setCustomerDetails(customerData);
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            window.dispatchEvent(new CustomEvent("qr-bootstrap-unauthorized", {
              detail: {
                source: "Order detail",
                error: err,
              },
            }));
          }
          console.error(err);
        });
    }
  }, [order_id]);

  const addForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      ordered_items: [...getStoredCartItems()],
      customer_name: customerDetails?.customer_name || "",
      customer_phone_number: customerDetails?.customer_phone_number || "",
      number_of_persons: customerDetails?.number_of_persons || "",
      customer_note: customerDetails?.customer_note || "",
      parent_id: order_id || "",
      tag: customerDetails?.tag || null,
      base: "",
      service_charge_percentage: ChargeSettings?.service_charge != null
        ? Number(ChargeSettings.service_charge).toFixed(0)
        : 0

    },
    validationSchema: Yup.object({
      ordered_items: Yup.array().min(1, t("err_item_required")),
      number_of_persons: Yup.number().required(t("err_no_of_person")),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const latestLineSessionToken =
        lineAuth?.line_session_token ||
        lineSessionTokenRef.current ||
        getLatestStoredLineAuth()?.line_session_token ||
        null;

      let formData = {
        ...values,
        // Addon quantity travels through the cart as a count on one entry (so a
        // line stays editable), but the wire contract is REPEAT ENTRIES: the
        // backend prices each entry, and the kitchen ticket collapses identical
        // ones back into "name ×N". Expanded here, once, at the boundary.
        ordered_items: expandAddonQuantities(values?.ordered_items),
        restaurant_id,
        table_id,
        type: order_id ? ORDER_TYPES.SUB_ORDER : ORDER_TYPES.BASE_ORDER,
        tag: values.tag,
        ...(getSubTotalQRApp(values?.ordered_items, ChargeSettings) || {}),
        parent_id: order_id || "",
        base: base,
        staff_id: base === ORDER_PLATFORM.APP ? staff_id : null,
        line_session_token: latestLineSessionToken,
      };
      setIsSubmitted(true);
      createOrder(formData, { token: token })
        .then((response) => {
          setIsSubmitted(false);
          if (response.success) {
            endVisit(restaurant_id, table_id);
            if (base === ORDER_PLATFORM.WEB) {
              Swal.fire({
                icon: "success",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
            else {
              const appData = { action: 'show-success', data: handleServerValidations(response) };
              postAppMessage(appData);

            }

            resetForm();
            dispatch(SetCartLength(0));
            const mySearchParams = new URLSearchParams(window.location.search);
            mySearchParams.set(
              "order_id",
              response?.data?.orderData?.parent_id
                ? response?.data?.orderData?.parent_id
                : response?.data?.orderData?._id
            );
            if (base === ORDER_PLATFORM.WEB) {
              navigate({
                pathname: "/qr-order/place",
                search: mySearchParams.toString(),
              });
            }
            else {
              navigate({
                pathname: "/qr-order/success",
                search: mySearchParams.toString(),
              });
            }

          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((err) => {
          setIsSubmitted(false);
          Swal.fire({
            icon: "error",
            text: t("try_again"),
            ...SWAL_SETTINGS,
          });
          if (err?.response?.status === 401) {
            window.dispatchEvent(new CustomEvent("qr-bootstrap-unauthorized", {
              detail: {
                source: "Create order",
                error: err,
              },
            }));
          }
          Swal.fire({
            icon: "error",
            text: err?.response?.data?.message || t("try_again"),
            ...SWAL_SETTINGS,
          });
          console.error(err);
        });
    },
  });

  useEffect(() => {
    setPricing(
      getSubTotalQRApp(addForm?.values?.ordered_items, ChargeSettings, {
        handleTaxSettings: true,
      })
    );
  }, [addForm?.values?.ordered_items, ChargeSettings]);

  const lineGate = useMemo(() => {
    // LINE login is only required for web QR orders at restaurants that have
    // enabled it — mirrors the backend gate (createOrder). Non-LINE restaurants
    // order unchanged.
    if (base !== ORDER_PLATFORM.WEB || !ChargeSettings?.line_enabled) {
      return { passed: true, message: "" };
    }

    if (!lineAuth?.line_session_token) {
      return {
        passed: false,
        message: lineAuthError || t("line_login_required"),
        type: "login",
      };
    }

    if (lineAuth?.is_blocked) {
      return {
        passed: false,
        message: t("line_customer_blocked"),
        type: "blocked",
      };
    }

    if (lineAuth?.is_friend !== true) {
      return {
        passed: false,
        message: t("line_friend_required"),
        type: "friend",
      };
    }

    return { passed: true, message: "", type: "ready" };
  }, [base, lineAuth, lineAuthError, ChargeSettings?.line_enabled]);

  const showLinePanel =
    base === ORDER_PLATFORM.WEB &&
    (ChargeSettings?.line_enabled || lineAuth?.line_session_token || lineAddFriendUrl);
  const lineStatusHint = lineGate.passed
    ? t("line_connected")
    : lineGate.type === "blocked"
      ? t("line_verify_blocked")
      : lineStatusChecking
        ? t("line_checking_status")
        : hasActivePendingFriendCheck
          ? t("line_verify_title")
          : !lineAuth?.line_session_token
            ? t("line_connecting")
            : t("line_verify_title");
  const primaryLineAction = lineGate.passed
    ? {
      label: t("line_connected"),
      onClick: null,
      disabled: true,
      className: "btn btn-outline-success w-100",
    }
    : lineGate.type === "blocked"
      ? {
        label: t("line_ordering_blocked"),
        onClick: null,
        disabled: true,
        className: "btn btn-outline-danger w-100",
      }
      : !lineAuth?.line_session_token
        ? {
          label: lineLoading ? t("line_connecting") : t("line_add_friend"),
          onClick: startLineLogin,
          disabled: lineLoading,
          className: "btn btn-success w-100",
        }
        : {
          label: t("line_add_friend"),
          onClick: startAddFriendFlow,
          disabled: !lineAddFriendUrl,
          className: "btn btn-success w-100",
        };

  const handlePlaceOrderAttempt = async () => {
    const errors = await addForm.validateForm();

    if (Object.keys(errors).length) {
      addForm.setTouched(
        {
          ordered_items: true,
          number_of_persons: true,
        },
        true
      );

      const firstError = errors.number_of_persons || errors.ordered_items;
      if (firstError) {
        Swal.fire({
          icon: "error",
          text: translatedError(firstError),
          ...SWAL_SETTINGS,
        });
      }
      return;
    }

    addForm.submitForm();
  };

  const translatedError = (message) => {
    if (!message) return "";
    return t(message);
  };

  const deleteRecord = (item) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: t("btn_delete_text"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("btn_delete"),
      cancelButtonText: t("btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        let data = [...addForm.values?.ordered_items];
        const index = data?.findIndex((record) => record.temp_item_id === item?.temp_item_id);
        if (index !== -1) {
          data.splice(index, 1);
          addForm.setFieldValue("ordered_items", data);
          saveVisitCart(restaurant_id, table_id, data)
        }
      }
    });
  };

  const handleAsterisk = (item) => {
    let result = null;
    if (
      item?.consumption_tax_rate === CONSUMPTION_TAX_RATES.TAKE_OUT &&
      ChargeSettings?.icon_display_eligible_for_reduced_tax_rate
    ) {
      result = <span className="fw-bold">*</span>;
    }
    return result;
  };



  // ---- Set-line rows, shared behaviour with the add sheet (addMenu) ----------
  // The rows ARE `formik.values.addons` — one array, no parallel copy. Every
  // mutation goes through here so the line price is never left stale: editing a
  // line can now add a premium component, and a price that did not follow would
  // bill the diner the pre-edit total.
  // The picker hands back an updater rather than a list, so the step is applied
  // to the rows the form holds NOW — two taps in one batch both land.
  //
  // Applied to a ref rather than to `formik.values.addons`: reading the rendered
  // values is exactly the read the updater exists to avoid, since two steps
  // dispatched inside one React batch would both see the pre-batch array and the
  // second would drop the first. The ref is re-seeded from the form on every
  // render, so it follows a reset or a re-open, and is advanced here so a second
  // call in the same batch composes on top of the first.
  const addonRowsRef = useRef([]);

  const applyAddonRows = (update) => {
    const updatedAddons = update(addonRowsRef.current);
    addonRowsRef.current = updatedAddons;
    formik.setFieldValue("addons", updatedAddons);
    recalculateSetLine(updatedAddons);
  };

  const recalculateSetLine = (updatedAddons) => {
    if (selectedItem?.type !== ITEM_TYPES.SET_OF_ITEMS) return;
    // A quantity of N contributes its gross N times, mirroring the N entries the
    // order payload carries and the N premiums the backend prices.
    const addons = expandByQuantity((updatedAddons || []).filter((a) => a.item_id));
    const { price, tax_price, total_price } = calculateSetMenuPrice(
      currentItem,
      addons,
      ChargeSettings?.tax_when_register_product
    );
    formik.setFieldValue("price", price);
    formik.setFieldValue("tax_price", tax_price);
    formik.setFieldValue("total_price", total_price);
  };


  const handleChangeQuantity = (item, type, quantity) => {
    let allItems = [...addForm?.values?.ordered_items];
    if (type === "increase") {
      if (item.type === ITEM_TYPES.ITEM && !item.spice_level_needed) {
        const index = allItems.findIndex(record => record?.temp_item_id === item?.temp_item_id);
        allItems[index].quantity += 1;
      } else {
        if (item.spice_level_needed || item.addons.length > 0) {
          fetchMenuItemDetail(item?._id).then(() => {
            let elem = document.getElementById("increaseQuantity");
            elem.click();
          });
        } else {
          allItems.push(item);
        }
      }
    } else {
      const index = allItems.findLastIndex((record) => record?.temp_item_id === item?.temp_item_id);
      if (index >= 0) {
        if (quantity > 1) {
          allItems[index].quantity -= 1;
        } else {
          allItems.splice(index, 1);
        }
      }
    }
    addForm.setFieldValue("ordered_items", allItems);
    saveVisitCart(restaurant_id, table_id, allItems)
  };

  const fetchMenuItemDetail = (_id, formType = "add", defaultValues = {}) => {
    return new Promise((resolve, reject) => {
      menuItemDetail({ o_id: _id }, { token: token })
        .then((response) => {
          setCurrentItem(response?.data);
          if (response?.data.type === ITEM_TYPES.ITEM) {
            let updatedItem = {};
            if (formType === "add") {
              updatedItem = {
                form_type: formType,
                ...response.data,
                // spice_level: response?.data?.spice_level_needed
                //   ? SPICE_LEVELS.LOW
                //   : null,
                // spice_level: response?.data?.spice_level_needed ? (optionsData[0]?._id || null) : null,
                spice_level: response?.data?.spice_level_needed ? (optionsData[0] || null) : null,
                spice_level_needed: response?.data?.spice_level_needed || false,
              };
            } else {
              updatedItem = { ...defaultValues, form_type: formType, };
            }
            formik.setValues(updatedItem);
            setSelectedItem(updatedItem);
          } else {
            let data = {};
            if (formType === "add") {
              data = {
                form_type: formType,
                ...response?.data,
                addons: response?.data?.addons?.map((addon) => {
                  return {
                    item_id: "",
                    item_name: "",
                    item_name_ja: "",
                    spice_level: null,
                    spice_level_needed: false,
                    addon_id: addon?._id,
                    addon_name: addon.addon_name,
                    items: addon.items,
                  };
                }),
              };
            } else {
              data = { ...defaultValues, form_type: formType };
            }
            setSelectedItem(data);
            formik.setValues(data);
          }
          setTimeout(() => {
            resolve(response);
          }, 100);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  };

  const formik = useFormik({
    initialValues: {
      spice_level: selectedItem?.spice_level || null,
      addons:
        selectedItem?.addons?.map((addon) => ({
          ...addon,
          item_id: addon.item_id || "",
          spice_level: addon.spice_level || null,
          spice_level_needed: addon.spice_level_needed || false,
          // The cart line keeps a count so it stays editable in one place;
          // `expandAddonQuantities` turns it into repeat entries at submit.
          quantity: unitsOf(addon),
        })) || [],
    },

    validate: (values) => {
      const errors = {};

      // Validate only for set of items / combo
      if (values.type === ITEM_TYPES.SET_OF_ITEMS || selectedItem.type === ITEM_TYPES.SET_OF_ITEMS) {
        const invalidAddon = values.addons?.find((addon) => {
          // addon item must be selected
          if (!addon.item_id) return true;

          // spice level required but not selected
          if (addon.spice_level_needed && !addon.spice_level) return true;

          return false;
        });

        if (invalidAddon) {
          errors.addons = "Please select addon item and required spice level";
        }
      }

      return errors;
    },

    onSubmit: (values, { resetForm }) => {

      // The shared key, not a local copy: it carries the GROUP the component was
      // picked under and its quantity, both of which move the price. A key
      // missing either merges two differently-priced configurations into one
      // line and bills the survivor's price for both.
      function getAddonArray(item) {
        return item.addons.map(getAddonKey);
      }

      let allItems = [...addForm.values?.ordered_items];

      if (values.form_type === "add") {
        if (selectedItem.type === ITEM_TYPES.ITEM) {
          const index = allItems.findIndex(
            (record) =>
              record._id === selectedItem._id &&
              // record.spice_level === values.spice_level
              record.spice_level?._id === values.spice_level?._id
          );

          if (index !== -1) {
            allItems[index].quantity += 1;
          } else {
            allItems.push({
              ...values,
              quantity: 1,
              temp_item_id: getUniqueID("selected-item-"),
            });
          }
        } else {
          const item = { ...values };
          const comboAddons = item.addons.map(getAddonKey);

          const index = allItems.findIndex(
            (record) =>
              record._id === item._id &&
              isSameArray(comboAddons, getAddonArray(record))
          );

          if (index !== -1) {
            allItems[index].quantity += 1;
          } else {
            allItems.push({
              ...values,
              quantity: 1,
              temp_item_id: getUniqueID("selected-item-"),
            });
          }
        }
      } else {
        let index = allItems.findIndex(
          (record) => record.temp_item_id === values.temp_item_id
        );

        if (selectedItem.type === ITEM_TYPES.ITEM) {
          let similarIndex = allItems.findIndex(
            (record) =>
              record.temp_item_id !== values.temp_item_id &&
              record._id === values._id &&
              record.spice_level === values.spice_level
          );

          if (similarIndex === -1) {
            allItems[index] = values;
          } else {
            allItems[similarIndex].quantity += values.quantity;
            allItems.splice(index, 1);
          }
        } else {
          const item = { ...values };
          const comboAddons = item.addons.map(getAddonKey);

          let similarIndex = allItems.findIndex(
            (record) =>
              record.temp_item_id !== values.temp_item_id &&
              record._id === item._id &&
              isSameArray(comboAddons, getAddonArray(record))
          );

          if (similarIndex === -1) {
            allItems[index] = values;
          } else {
            allItems[similarIndex].quantity += values.quantity;
            allItems.splice(index, 1);
          }
        }
      }

      addForm.setFieldValue("ordered_items", allItems);
      saveVisitCart(restaurant_id, table_id, allItems);
      resetForm();
    },
  });

  // Formik is initialized above before reading its values during render.
  // Keeping this sync here also ensures the ref follows resets and re-opens.
  addonRowsRef.current = formik.values.addons || [];

  useEffect(() => {
    if (addForm.values.number_of_persons) {
      return;
    }
    const known = knownGuestCount(tableDetails, readReviewDraft(restaurant_id, table_id));
    if (known) {
      addForm.setFieldValue("number_of_persons", known);
    }
  }, [tableDetails, addForm.values.number_of_persons]);

  useEffect(() => {
    const draft = {
      customer_name: addForm.values.customer_name || "",
      customer_phone_number: addForm.values.customer_phone_number || "",
      number_of_persons:
        addForm.values.number_of_persons ||
        readReviewDraft(restaurant_id, table_id)?.number_of_persons ||
        "",
      customer_note: addForm.values.customer_note || "",
      tag: addForm.values.tag || null,
    };
    saveReviewDraft(restaurant_id, table_id, draft);
  }, [
    addForm.values.customer_name,
    addForm.values.customer_note,
    addForm.values.customer_phone_number,
    addForm.values.number_of_persons,
    addForm.values.tag,
    restaurant_id,
    table_id,
  ]);


  useEffect(() => {
    let result = 0;
    addForm?.values?.ordered_items.forEach((record) => {
      result += record?.quantity;
    });
    dispatch(SetCartLength(result));
  }, [addForm?.values?.ordered_items]);

  const taxBreakdown = getTaxBracketBreakdown(pricing);

  return (
    <>
      <form className="form-flex-layout" onSubmit={addForm.handleSubmit}>
        <div className="qr-body-wrap">
          <div className="p-3">
            <div className="form-review-order">
              <div className="mb-3">
                <label className="form-label">
                  {t("number_of_person_text")}
                  <span>*</span>
                </label>
                <select
                  className="form-control form-control-placeholder cp"
                  name="number_of_persons"
                  value={addForm?.values?.number_of_persons}
                  onChange={(e) => {
                    addForm.setFieldValue(
                      "number_of_persons",
                      e.target.value ? Number(e.target.value) : ""
                    );
                  }}
                >
                  <option value={""}>{t("input_select_text")}</option>
                  {numberOfPersonOptions?.map((option, index) => {
                    return (
                      <option value={option} key={index}>
                        {option}
                      </option>
                    );
                  })}
                </select>
                <CustomError
                  className="text-danger"
                  name="number_of_persons"
                  form={addForm}
                />
              </div>
              {
                base === ORDER_PLATFORM.APP &&
                <div className="mb-3">
                  <label className="form-label">
                    {t("label_customer_tag")}
                  </label>
                  <select
                    className="form-control form-control-placeholder cp"
                    name="tag"
                    value={addForm?.values?.tag}
                    onChange={addForm.handleChange}
                  >
                    <option value={""}>{t("input_select_text")}</option>
                    <option value={CUSTOMER_TAGS.VIP}>{t("tag_vip")}</option>
                    <option value={CUSTOMER_TAGS.REGULAR}>{t("tag_regular")}</option>

                  </select>
                </div>
              }
            </div>
            {addForm?.values?.ordered_items?.length ? (
              <div className="items-edit-delete">
                <h4>{t("label_items")} </h4>
                <div className="d-flex gap-2 flex-column">
                  {addForm?.values?.ordered_items?.map(
                    (item, index) => {
                      return (
                        <div className="card card-2" key={index}>
                          <div className="p-2">
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="">
                                <span className="d-block">
                                  {getTranslatedKey("item_name", item)}{" "}
                                  {handleAsterisk(item)}{" "}
                                  {item?.quantity > 1 ? (
                                    <strong>{`(x${item?.quantity})`}</strong>
                                  ) : null}
                                  <br />
                                  {item?.spice_level ? (
                                    <span className="fs-12">
                                      {t("spice_level_text")} -{" "}
                                      <strong>
                                        {getSpiceName(item?.spice_level)}
                                      </strong>
                                    </span>
                                  ) : null}
                                </span>
                                {item?.type === ITEM_TYPES.SET_OF_ITEMS ? (
                                  <div className="w-100 pt-2">
                                    {item?.addons?.map(
                                      (addon, addonIndex) => {
                                        return (
                                          <div
                                            className={
                                              "border p-2 rounded-2 mb-2" +
                                              (addonIndex + 1 <
                                                item?.addons?.length
                                                ? " me-1"
                                                : "")
                                            }
                                            key={addonIndex}
                                          >
                                            <span className="d-block fs-12">
                                              {getTranslatedKey(
                                                "item_name",
                                                addon
                                              )}
                                              {addon?.count > 1 ? (
                                                <strong>{`(x${addon?.count})`}</strong>
                                              ) : null}
                                            </span>
                                            {addon?.spice_level ? (
                                              <span className="d-block fs-12">
                                                {t("spice_level_text")} -{" "}
                                                <strong>
                                                  {getSpiceName(addon?.spice_level)}
                                                </strong>
                                              </span>
                                            ) : null}
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                ) : null}
                                <small>

                                  ¥ {ChargeSettings?.display_method_product_price === DISPLAY_METHOD_TAX_OPTIONS.TAX_EXCLUDED ? showPrice(item?.price * item?.quantity) : showPrice(item?.total_price * item?.quantity)}
                                </small>
                              </div>
                              <div>
                                <div className="border border-1 rounded-1 mb-2 quantity-box d-flex justify-content-between">
                                  <button
                                    className="btn btn-sm py-1 px-2 h-auto"
                                    type="button"
                                    disabled={item?.quantity <= 1}
                                    onClick={() => {
                                      handleChangeQuantity(
                                        item,
                                        "decrease",
                                        item?.quantity
                                      );
                                    }}
                                  >
                                    <i className="ti ti-minus"></i>
                                  </button>
                                  <span className="d-flex align-items-center">
                                    {item?.quantity}
                                  </span>
                                  <button
                                    className="btn btn-sm py-1 px-2 h-auto"
                                    type="button"
                                    onClick={() => {
                                      handleChangeQuantity(
                                        item,
                                        "increase",
                                        item?.quantity
                                      );
                                    }}
                                  >
                                    <i className="ti ti-plus"></i>
                                  </button>
                                </div>
                                <div className="d-flex gap-2">
                                  <button
                                    type="button"
                                    disabled={item?.type === ITEM_TYPES.ITEM && item?.spice_level_needed === false}
                                    onClick={() => {
                                      fetchMenuItemDetail(item?._id, "edit", item).then(() => {
                                        let elem = document.getElementById("increaseQuantity");
                                        elem.click();
                                      });
                                    }}
                                    className="btn btn-icon btn-sm h-auto py-2 no-color-disabled"
                                  >
                                    <i className="ti ti-edit"></i>
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      deleteRecord(item);
                                    }}
                                    className="btn btn-icon btn-danger  btn-sm h-auto py-2"
                                  >
                                    <i className="ti ti-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            ) : (
              <div className="items-edit-delete">
                <h4>{t("no_order_text")}</h4>
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => {
                    const searchParams = location.search;
                    navigate(`/qr-order${searchParams}`);
                  }}
                >
                  {t("select_item_label")}
                </button>
                <CustomError
                  className="text-danger"
                  name="ordered_items"
                  form={addForm}
                />
              </div>
            )}
            <div className="mb-3 mt-4">
              <label className="form-label">{t("requirement_text")}</label>
              <textarea
                style={{ height: "120px" }}
                placeholder={t("write_a_note")}
                className="form-control form-control-placeholder"
                name="customer_note"
                value={addForm?.values?.customer_note}
                onChange={addForm.handleChange}
              ></textarea>
            </div>
            {addForm?.values?.ordered_items?.length ? (
              <div className="info-order-review">
                <div className="card card-2">
                  <div className="p-2">
                    <table width={"100%"}>
                      <tbody>
                        <tr className="qr-tax-bracket-row">
                          <td>{t("label_dine_in_subtotal")}</td>
                          <td className="text-end">
                            ¥ {showPrice(taxBreakdown.dineInSubtotal)}
                          </td>
                        </tr>
                        <tr className="qr-tax-bracket-row">
                          <td>{t("label_take_out_subtotal")}</td>
                          <td className="text-end">
                            ¥ {showPrice(taxBreakdown.takeOutSubtotal)}
                          </td>
                        </tr>
                        <tr className="fw-bold">
                          <td>
                            {t("sub_total_label")}(
                            {addForm?.values?.ordered_items?.length}{" "}
                            {pluralText(
                              addForm?.values?.ordered_items?.length,
                              t("label_item"),
                              t("label_items")
                            )}
                            )
                          </td>
                          <td className="text-end">
                            ¥ {showPrice(pricing?.subtotal)
                            }
                          </td>
                        </tr>

                        {pricing?.service_charge && ChargeSettings?.is_service_charge_enabled ? (
                          <tr>
                            <td>{t("service_charge")}</td>
                            <td className="text-end">
                              ¥ {showPrice(pricing?.service_charge)}
                            </td>
                          </tr>
                        ) : null}

                        <tr className="qr-tax-bracket-row">
                          <td>10% {t("label_dine_in_tax")}</td>
                          <td className="text-end">
                            ¥ {showPrice(taxBreakdown.dineInTax)}
                          </td>
                        </tr>
                        <tr className="qr-tax-bracket-row">
                          <td>8% {t("label_take_out_tax")}</td>
                          <td className="text-end">
                            ¥ {showPrice(taxBreakdown.takeOutTax)}
                          </td>
                        </tr>
                        <tr className="fw-bold">
                          <td>{t("label_consumption_tax")}</td>
                          <td className="text-end">
                            ¥ {showPrice(pricing?.tax_price)}
                          </td>
                        </tr>

                        <tr>
                          <td colSpan={2} className="text-end">
                            {
                              pricing?.total_tax_8 && pricing?.total_tax_8 > 0 && ChargeSettings.icon_display_eligible_for_reduced_tax_rate ? <span class="d-block no-wrap">* {t('tax_on_other_text')} <br />{t('tax_rate_8')}</span> : ""
                            }
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h4>{t("grand_total_text")}</h4>
                          </td>
                          <td className="text-end">
                            <h4>¥ {Number(showPrice(pricing?.grand_total))}</h4>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </form>
      <div className="cart-bottom p-3">
        {showLinePanel ? (
          <LineVerificationCard
            lineGate={lineGate}
            lineAuth={lineAuth}
            lineAddFriendUrl={lineAddFriendUrl}
            lineLoading={lineLoading}
            lineStatusChecking={lineStatusChecking}
            primaryLineAction={primaryLineAction}
            refreshFriendStatus={refreshFriendStatus}
            onTroubleClick={() => document.getElementById("lineTroubleModal")?.click()}
            t={t}
          />
        ) : null}
        <button
          className="btn btn-primary w-100"
          type="button"
          onClick={handlePlaceOrderAttempt}
          disabled={isSubmitted || !lineGate.passed}
        >
          {isSubmitted ? (
            <>
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>{" "}
              {t("placing_order_label")}
            </>
          ) : (
            t("place_order_label")
          )}
        </button>
      </div>
      <button
        className="btn btn-dark w-100 mt-2 d-none"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal2"
        id="increaseQuantity"
      ></button>
      <div
        className="modal fade qr-modal"
        id="exampleModal2"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              {selectedItem?.type === ITEM_TYPES.ITEM ? (
                <>
                  {selectedItem?.spice_level_needed ? (
                    <>
                      <div className="p-2">
                        <div className="head-veg-card d-flex align-items-center justify-content-between mb-2">
                          <h4>
                            {t("label_spice_level_for")}{" "}
                            {getTranslatedKey(
                              selectedItem.item_name,
                              selectedItem
                            )}
                          </h4>
                        </div>
                        <div className="veg-tags">
                          <ul className="spice-gap">
                            {optionsData?.map((spice) => (
                              <li key={spice._id}>
                                <div className="check-input-tick">
                                  <input
                                    type="radio"
                                    className="cp"
                                    name="spice_level"
                                    id={`spice_level_${spice._id}_${selectedItem?._id}`}
                                    value={spice._id}
                                    checked={formik.values.spice_level?._id === spice._id}
                                    onChange={() => formik.setFieldValue('spice_level', spice)}
                                  />
                                  <label htmlFor={`spice_level_${spice._id}_${selectedItem?._id}`} className="cp">
                                    <i className="ti ti-circle-check"></i> {getTranslatedKey('name', spice) || spice?.name}
                                  </label>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="d-flex gap-3 mt-4 addon-modal-actions">
                        <button
                          className="btn btn-gry w-100"
                          data-bs-dismiss="modal" type="button"
                        >
                          {t("false_label_no")}
                        </button>
                        <button
                          className="btn btn-primary w-100"
                          onClick={formik.handleSubmit}
                          data-bs-dismiss="modal"
                          type="button"
                        >
                          {t("btn_update")}
                        </button>
                      </div>
                    </>
                  ) : (
                    <h4 className="mb-3">{t("label_choose_option")}</h4>
                  )}
                </>
              ) : (
                <>
                  {/* The same picker the add sheet renders — one collapsible
                      section per configured group, listing that group's options.
                      This screen used to carry its own copy that had fallen a
                      release behind. */}
                  <SetMenuAddonPicker
                    groups={currentItem?.addons}
                    rows={formik.values.addons}
                    spiceOptions={optionsData}
                    onChangeRows={applyAddonRows}
                  />
                  <div className="d-flex gap-3 mt-4 addon-modal-actions">
                    <button
                      className="btn btn-gry w-100"
                      data-bs-dismiss="modal"
                      onClick={formik.resetForm}
                      type="button"
                    >
                      {t("false_label_no")}
                    </button>
                    <button
                      className="btn btn-primary w-100"
                      onClick={formik.handleSubmit}
                      data-bs-dismiss="modal"
                      type="button"
                      disabled={
                        !formik?.values?.addons?.length ||
                        formik?.values?.addons?.some(addon => !addon?.item_id)
                      }
                    >
                      {t("btn_update")}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {lineAddFriendUrl ? (
        <LineTroubleModal
          lineAddFriendUrl={lineAddFriendUrl}
          lineLoading={lineLoading}
          lineStatusChecking={lineStatusChecking}
          startLineLogin={startLineLogin}
          refreshFriendStatus={refreshFriendStatus}
          t={t}
        />
      ) : null}
    </>
  );
}
